import CloseIcon from '@mui/icons-material/Close';
import { Breakpoint } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { CSSProperties, ReactChild } from 'react';

/**
 * Light wrapper over Dialog for convenience
 */
export default function ModalDialog(p: {
  isCloseable?: boolean;
  title?: ReactChild;
  onClose?: () => void;
  children?: React.ReactChild | React.ReactChild[];
  classNames?: {
    title?: string;
    content?: string;
  };
  fullWidth?: boolean;
  padding?: number;
  sx?: any;
}) {
  return (
    <Dialog sx={p.sx} fullWidth={p.fullWidth} open={true} onClose={p.onClose}>
      {p.title && (
        <DialogTitle className={p.classNames?.title}>{p.title}</DialogTitle>
      )}

      {p.isCloseable && (
        <CloseIcon
          onClick={p.onClose}
          sx={{
            position: 'absolute',
            right: '1rem',
            top: '1rem',
            cursor: 'pointer',
          }}
        />
      )}
      <DialogContent
        style={{ padding: p.padding }}
        className={p.classNames?.content}
        children={p.children}
      />
    </Dialog>
  );
}
